import { Group, Stack, Switch } from "@mantine/core"
import { ColumnManager, ExportButton, ExportType } from "@tfg/ui"
import { Dispatch, SetStateAction, useState } from "react"
import { useTranslation } from "react-i18next"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"
import { useGetColumnManagerTranslations } from "~/hooks/table"
import { useGetAgecExportColumns } from "~/pages/Admin/Exports/AgecStats/export-columns"
import { useExportAGECStatsMutation } from "~/pages/Admin/Exports/AgecStats/hooks/useExportAGECStatsMutation"

type Props = {
  agecStats: AdminResponses.FindAllAgecStatsResponseDto
  groupByCollection: boolean
  setGroupByCollection: Dispatch<SetStateAction<boolean>>
}

export const AgecStatsTable = ({
  agecStats,
  groupByCollection,
  setGroupByCollection,
}: Props) => {
  const columns = useGetAgecExportColumns()
  const { mutate: csvDownload, isPending: isAgecStatsExportLoading } =
    useExportAGECStatsMutation()
  const { t } = useTranslation(["products", "common"])
  const columnManagerTranslations = useGetColumnManagerTranslations()
  const [isColumnManagerOpen, setIsColumnManagerOpen] = useState<boolean>(false)
  const table = useCustomReactTable({
    data: agecStats.agecStats,
    columns,
  })

  return (
    <Stack>
      <Group justify="space-between">
        <Group>
          <ColumnManager
            table={table}
            translations={columnManagerTranslations}
            isOpen={isColumnManagerOpen}
            setIsOpen={setIsColumnManagerOpen}
          />
          <Switch
            label="Stats by collection"
            checked={groupByCollection}
            onChange={() => setGroupByCollection(!groupByCollection)}
          />
        </Group>
        <Group>
          <ExportButton
            label={t("lists.export.all")}
            exportOptions={[
              {
                type: ExportType.CSV,
                label: t("common:actionButtons.exportAsCsv"),
                exportFunction: () =>
                  csvDownload({ params: { groupByCollection } }),
                isLoading: isAgecStatsExportLoading,
              },
            ]}
          />
        </Group>
      </Group>
      <CustomTable
        pagination={false}
        table={table}
        setOpenColumnManager={setIsColumnManagerOpen}
      />
    </Stack>
  )
}
